import { Tooltip } from '@cred/react-tooltip'
import { withTooltipInteraction } from '@cred/react-analytics/hoc'

const TooltipWithAnalytics = withTooltipInteraction(Tooltip)

export default TooltipWithAnalytics
